module.exports = __webpack_public_path__ + "media/images/emblems/Minusio-coat_of_arms-f6ae0fccf33b8f8f5f0787d9561cb846.svg";